/** @deprecated Use BOOLEAN_TWO instead */
export enum BOOLEAN {
  "FALSE" = 1,
  "TRUE" = 2
}
